// File: src/api/categories.js
import { request } from './client';

export const categoryService = {
  // --- CATEGORY OPERATIONS ---
  
  getCategories: () => request('/categories'),
  
  createCategory: (data) => 
    request('/categories', { method: 'POST', body: data }),
  
  updateCategory: (id, data) => 
    request(`/categories/${id}`, { method: 'PUT', body: data }),
  
  deleteCategory: (id) => 
    request(`/categories/${id}`, { method: 'DELETE' }),

  // Remove User from Category
  removeUserFromCategory: (catId, userId) => 
    request(`/categories/${catId}/remove-user`, { 
      method: 'PUT', 
      body: { userIdToRemove: userId } 
    }),
};
